/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWmv = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m9.646 15.682.705-2.425h.695l.731 2.395.553-2.611h.831l-.869 3.922h-.809l-.804-2.64-.76 2.64h-.81L8.24 13.04h.853zm6.118-.057 1.23-2.584h.879v3.922h-.831v-2.541l-1.036 2.163h-.518l-1.036-2.129v2.507h-.814V13.04h.879zm4.396.304.927-2.888h.912l-1.446 3.922h-.815l-1.446-3.922h.95z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileWmv as FileWmv };
